import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=e0caef4a&scoped=true"
import script from "./app-menu.vue?vue&type=script&lang=ts"
export * from "./app-menu.vue?vue&type=script&lang=ts"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=e0caef4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0caef4a",
  null
  
)

export default component.exports